"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SHORT: 1,
  NUMBER: 2,
  LONG: 3,
  BOOLEAN: 4,
  RELATION: 5,
  RATE: 6
};
var EnumColumnType;

(function (EnumColumnType) {
  EnumColumnType[EnumColumnType["SHORT"] = 1] = "SHORT";
  EnumColumnType[EnumColumnType["NUMBER"] = 2] = "NUMBER";
  EnumColumnType[EnumColumnType["LONG"] = 3] = "LONG";
  EnumColumnType[EnumColumnType["BOOLEAN"] = 4] = "BOOLEAN";
  EnumColumnType[EnumColumnType["RELATION"] = 5] = "RELATION";
  EnumColumnType[EnumColumnType["RATE"] = 6] = "RATE";
})(EnumColumnType = exports.EnumColumnType || (exports.EnumColumnType = {}));

var EnumColumnRelationType;

(function (EnumColumnRelationType) {
  EnumColumnRelationType["ITEM"] = "ITEM";
})(EnumColumnRelationType = exports.EnumColumnRelationType || (exports.EnumColumnRelationType = {}));